import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { User } from '../admin/1.tv/models/user.model';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(
    private db: AngularFirestore,
  ) { }


  getUsersById$(userId: string): Observable<any> {
    const ret = this.db.collection('users').doc(userId);

    return ret.snapshotChanges()
      .pipe(
        map((x) => {
          const data = x.payload.data() as any;
          const id = x.payload.id;
          return { id, ...data };
        })

      );
  }

  // Old way with returning an array of 1
  // getUsersById$(userId: string): Observable<any> {

  //   const usersCollection = this.db.collection<User>('users', ref => ref
  //     .where('uid', '==', userId)
  //   );

  //   return usersCollection.snapshotChanges()
  //     .pipe(
  //       map(actions => {
  //         return actions.map(a => {
  //           const data = a.payload.doc.data() as any;
  //           const id = a.payload.doc.id;
  //           return { id, ...data };
  //         });
  //       })
  //     );
  // }
}
